export const colors = {
  lightGray: 'rgba(0,0,0,0.15)',
  lenoxDark1: '#303841',
  lenoxDark2: '#3a4750',
  lenoxSuccess1: '#00adb5',
  lenoxLight1: '#FDFDFD',
  lenoxNegative: '#ff0000',
  moneyGreen: 'green'
};
